var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21C5.1 21 4.75 20.85 4.45 20.55C4.15 20.25 4 19.9 4 19.5V4.5C4 4.1 4.15 3.75 4.45 3.45C4.75 3.15 5.1 3 5.5 3H13.9C14.1 3 14.2958 3.04167 14.4875 3.125C14.6792 3.20833 14.8417 3.31667 14.975 3.45L19.55 8.025C19.6833 8.15833 19.7917 8.32083 19.875 8.5125C19.9583 8.70417 20 8.9 20 9.1V19.5C20 19.9 19.85 20.25 19.55 20.55C19.25 20.85 18.9 21 18.5 21H5.5ZM13.775 8.4V5H6V19H18V9.15H14.525C14.3083 9.15 14.1292 9.07917 13.9875 8.9375C13.8458 8.79583 13.775 8.61667 13.775 8.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.886f0f0e664533b8764696886f19f4e9.svg";
export { ForwardRef as ReactComponent };